export default __webpack_public_path__ + "static/media/Dr. Minati Das.cb678cda.png";